import { render, staticRenderFns } from "./PaymentConfirmationPage.vue?vue&type=template&id=30db6dec&scoped=true"
import script from "./PaymentConfirmationPage.vue?vue&type=script&lang=js"
export * from "./PaymentConfirmationPage.vue?vue&type=script&lang=js"
import style0 from "./PaymentConfirmationPage.vue?vue&type=style&index=0&id=30db6dec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30db6dec",
  null
  
)

export default component.exports